import React from 'react';
import { Helmet } from 'react-helmet';
import '../styles/Conocenos.css'; // Actualizar la ruta de importación

const Conocenos = () => (
    <div className="conocenos-container">
        <Helmet>
            <title>Conócenos</title>
            <meta property="og:title" content="Conócenos" />
            <meta property="og:description" content="Conoce más sobre nuestra escuela y su historia." />
            <meta property="og:image" content="https://primarturogro.edu.mx/uploads/LogoArturo.png" />
            <meta property="og:url" content="https://primarturogro.edu.mx/conocenos" />
            <meta property="og:type" content="website" />
        </Helmet>
        <h1>Conócenos</h1>
        <p>
            Bienvenido a nuestra institución. Aquí encontrarás información sobre nuestra misión, visión y valores.
        </p>
        <p>
            Nos dedicamos a ofrecer una educación de calidad, fomentando el desarrollo integral de nuestros estudiantes.
        </p>
        <p>
            Nuestro equipo de docentes está comprometido con la formación académica y personal de cada uno de nuestros alumnos.
        </p>
    </div>
);

export default Conocenos;